function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import { invariant, millisecondsToSeconds, secondsToMilliseconds, noop } from 'motion-utils';
import { setStyle } from '../render/dom/style-set.mjs';
import { supportsScrollTimeline } from '../utils/supports/scroll-timeline.mjs';
import { getFinalKeyframe } from './keyframes/get-final.mjs';
import { WithPromise } from './utils/WithPromise.mjs';
import { startWaapiAnimation } from './waapi/start-waapi-animation.mjs';
import { applyGeneratorOptions } from './waapi/utils/apply-generator.mjs';
/**
 * NativeAnimation implements AnimationPlaybackControls for the browser's Web Animations API.
 */

var NativeAnimation = /*#__PURE__*/function (_WithPromise) {
  _inherits(NativeAnimation, _WithPromise);

  var _super = _createSuper(NativeAnimation);

  function NativeAnimation(options) {
    var _this;

    _classCallCheck(this, NativeAnimation);

    _this = _super.call(this);
    _this.finishedTime = null;
    _this.isStopped = false;
    if (!options) return _possibleConstructorReturn(_this);
    var element = options.element,
        name = options.name,
        keyframes = options.keyframes,
        pseudoElement = options.pseudoElement,
        _options$allowFlatten = options.allowFlatten,
        allowFlatten = _options$allowFlatten === void 0 ? false : _options$allowFlatten,
        finalKeyframe = options.finalKeyframe,
        onComplete = options.onComplete;
    _this.isPseudoElement = Boolean(pseudoElement);
    _this.allowFlatten = allowFlatten;
    _this.options = options;
    invariant(typeof options.type !== "string", "animateMini doesn't support \"type\" as a string. Did you mean to import { spring } from \"motion\"?");
    var transition = applyGeneratorOptions(options);
    _this.animation = startWaapiAnimation(element, name, keyframes, transition, pseudoElement);

    if (transition.autoplay === false) {
      _this.animation.pause();
    }

    _this.animation.onfinish = function () {
      _this.finishedTime = _this.time;

      if (!pseudoElement) {
        var keyframe = getFinalKeyframe(keyframes, _this.options, finalKeyframe, _this.speed);

        if (_this.updateMotionValue) {
          _this.updateMotionValue(keyframe);
        } else {
          /**
           * If we can, we want to commit the final style as set by the user,
           * rather than the computed keyframe value supplied by the animation.
           */
          setStyle(element, name, keyframe);
        }

        _this.animation.cancel();
      }

      onComplete === null || onComplete === void 0 ? void 0 : onComplete();

      _this.notifyFinished();
    };

    return _this;
  }

  _createClass(NativeAnimation, [{
    key: "play",
    value: function play() {
      if (this.isStopped) return;
      this.animation.play();

      if (this.state === "finished") {
        this.updateFinished();
      }
    }
  }, {
    key: "pause",
    value: function pause() {
      this.animation.pause();
    }
  }, {
    key: "complete",
    value: function complete() {
      var _this$animation$finis, _this$animation;

      (_this$animation$finis = (_this$animation = this.animation).finish) === null || _this$animation$finis === void 0 ? void 0 : _this$animation$finis.call(_this$animation);
    }
  }, {
    key: "cancel",
    value: function cancel() {
      try {
        this.animation.cancel();
      } catch (e) {}
    }
  }, {
    key: "stop",
    value: function stop() {
      if (this.isStopped) return;
      this.isStopped = true;
      var state = this.state;

      if (state === "idle" || state === "finished") {
        return;
      }

      if (this.updateMotionValue) {
        this.updateMotionValue();
      } else {
        this.commitStyles();
      }

      if (!this.isPseudoElement) this.cancel();
    }
    /**
     * WAAPI doesn't natively have any interruption capabilities.
     *
     * In this method, we commit styles back to the DOM before cancelling
     * the animation.
     *
     * This is designed to be overridden by NativeAnimationExtended, which
     * will create a renderless JS animation and sample it twice to calculate
     * its current value, "previous" value, and therefore allow
     * Motion to also correctly calculate velocity for any subsequent animation
     * while deferring the commit until the next animation frame.
     */

  }, {
    key: "commitStyles",
    value: function commitStyles() {
      if (!this.isPseudoElement) {
        var _this$animation$commi, _this$animation2;

        (_this$animation$commi = (_this$animation2 = this.animation).commitStyles) === null || _this$animation$commi === void 0 ? void 0 : _this$animation$commi.call(_this$animation2);
      }
    }
  }, {
    key: "duration",
    get: function get() {
      var _this$animation$effec, _this$animation$effec2;

      var duration = ((_this$animation$effec = this.animation.effect) === null || _this$animation$effec === void 0 ? void 0 : (_this$animation$effec2 = _this$animation$effec.getComputedTiming) === null || _this$animation$effec2 === void 0 ? void 0 : _this$animation$effec2.call(_this$animation$effec).duration) || 0;
      return millisecondsToSeconds(Number(duration));
    }
  }, {
    key: "time",
    get: function get() {
      return millisecondsToSeconds(Number(this.animation.currentTime) || 0);
    },
    set: function set(newTime) {
      this.finishedTime = null;
      this.animation.currentTime = secondsToMilliseconds(newTime);
    }
    /**
     * The playback speed of the animation.
     * 1 = normal speed, 2 = double speed, 0.5 = half speed.
     */

  }, {
    key: "speed",
    get: function get() {
      return this.animation.playbackRate;
    },
    set: function set(newSpeed) {
      // Allow backwards playback after finishing
      if (newSpeed < 0) this.finishedTime = null;
      this.animation.playbackRate = newSpeed;
    }
  }, {
    key: "state",
    get: function get() {
      return this.finishedTime !== null ? "finished" : this.animation.playState;
    }
  }, {
    key: "startTime",
    get: function get() {
      return Number(this.animation.startTime);
    },
    set: function set(newStartTime) {
      this.animation.startTime = newStartTime;
    }
    /**
     * Attaches a timeline to the animation, for instance the `ScrollTimeline`.
     */

  }, {
    key: "attachTimeline",
    value: function attachTimeline(_ref) {
      var timeline = _ref.timeline,
          observe = _ref.observe;

      if (this.allowFlatten) {
        var _this$animation$effec3;

        (_this$animation$effec3 = this.animation.effect) === null || _this$animation$effec3 === void 0 ? void 0 : _this$animation$effec3.updateTiming({
          easing: "linear"
        });
      }

      this.animation.onfinish = null;

      if (timeline && supportsScrollTimeline()) {
        this.animation.timeline = timeline;
        return noop;
      } else {
        return observe(this);
      }
    }
  }]);

  return NativeAnimation;
}(WithPromise);

export { NativeAnimation };